import { SVGAttributes } from "react";

export default (props: SVGAttributes<any>) => {
  return (
    <>
      <svg {...props} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M3.25 7.67708C5.40104 5.29688 8.56771 3.75 11.9948 3.75C15.4219 3.75 18.5938 5.29688 20.75 7.67708"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
        ></path>
        <path
          d="M20.2238 12.75C19.3228 16.125 15.8748 18.75 11.9946 18.75C8.11442 18.75 4.67692 16.125 3.77588 12.75"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
        ></path>
        <path
          d="M12 19V21.25"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
        ></path>
        <path
          d="M16.0884 18.0261L17.2134 19.974"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
        ></path>
        <path
          d="M18.7759 15.5886L20.7238 17.2136"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
        ></path>
        <path
          d="M7.91162 18.0261L6.78662 19.974"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
        ></path>
        <path
          d="M5.2238 15.5886L3.27588 17.2136"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
        ></path>
      </svg>
    </>
  );
};
